var $ = jQuery.noConflict();

$(document).ready(function() {
  if ( $('.child-post-nav').length ) {
    console.log('hihi')
    $('.child-post-nav').slick({
      slidesToShow:8,
      slidesToScroll: 8,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
      
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
})


